import { useMemo } from 'react';
import { Link } from 'react-router-dom';
// Local imports
import classes from './index.module.scss';
import { Table } from './types';

function PriceListPage() {
	// CONSTANTS
	const priceTables = useMemo<Table[]>(
		() => [
			{
				title: 'Kezelések',
				rows: [
					['Arctisztítás (tini):', '12 000.-'],
					['Arctisztítás (felnőtt) - letisztítás, radírozás, gőzöléses felpuhítás masszírozással, tisztítás, ampulla, pakolás:', '15 200.-'],
					['Arctisztítás + vio:', '15 400.-'],
					['Arctisztítás + iontós hatóanyag-bevitel:', '17 000.-'],
					['Arctisztítás + thermos hatóanyag-bevitel:', '15 500.-'],
					['Arctisztítás + hidrodermabrázió:', '16 900.-'],
					['Arctisztítás + mikrodermabrázió:', '18 500.-'],
					['Arctisztítás + mikrodermabrázió + mezoterápia:', '22 900.-'],
					['Arctisztítás + mikrodermabrázió + iontoforézis:', '19 000.-'],
					['Hátkezelés (területtől függően):', '12 000 -', '18 000.-'],
					['AHA gyümölcssavas hámlasztás:', '17 000.-'],
					['AHA gyümölcssavas hámlasztás (prémium):', '20 000.-'],
					['Hialuron kezelés', '16 500.-'],
					['Collagen anti-ageing kezelés', '15 700.-'],
					['3 Peptid anti-ageing ránctalanító lifting kezelés', '18 500.-'],
					['Wine up lift (Jégboros kezelés)', '19 500.-'],
					['Arctisztítás + szemöldökszedés:', '16 500.-'],
					['Arctisztítás + szempillafestés:', '17 200.-'],
					['Arctisztítás + szemöldökszedés + szempillafestés:', '18 500.-'],
					['Arctisztítás + szempilla-, szemöldök festés és szedés:', '19 700.-'],
				],
			},
			{
				title: 'Frissítő kezelések',
				rows: [
					['Arcmasszázs + radír:', '6 400.-'],
					['Dekoltázsmasszázs + radír:', '7 800.-'],
					['Arcmasszázs + radír + pakolás:', '9 100.-'],
					['Arcmasszázs + mikrodermabrázió + pakolás:', '13 000.-'],
					['Arcmasszázs + mikrodermabrázió + iontoforézis:', '16 000.-'],
					['Dekoltázsmasszázs + radír + pakolás:', '11 400.-'],
					['Dekoltázsmasszázs + mikrodermabrázió + pakolás:', '18 000.-'],
					['Arcmasszázs + mikrodermabrázió + arcmezo', '19 800 -', '21 500.-'],
					['Radír (mechanikus):', '1 300.-'],
					['Radír (enzimes):', '1 700.-'],
					['Pakolások:', '2 300 -', '4 500.-'],
					['Vio:', '1100.-'],
					['Mikroforézis (hatóanyagtól függően):', '3 800 -', '5 000.-'],
					['Mikrodermabrázió arc + nyak + dekoltázs:', '4 700 -', '5 700.-'],
					['Hidrodermabrázió:', '4 300.-'],
				],
			},
			{
				title: 'Gyantázások',
				rows: [
					['Szemöldök:', '1 700.-'],
					['Bajusz:', '1 200.-'],
					['Áll:', '800.-'],
					['Arc:', '2 000.-'],
					['Hónalj:', '2 800.-'],
					['Kar:', '3 300.-'],
					['Hónalj + kar:', '5 200.-'],
					['Fazon:', '3 200.-'],
					['Fazon (teljes - elöl):', '4 900.-'],
					['Fazon (teljes - elöl + popsi):', '6 300.-'],
					['Láb (térdig):', '3 900.-'],
					['Láb (végig):', '6 900.-'],
					['Comb:', '4 300.-'],
					['Láb (végig) + fazon:', '9 900.-'],
					['Láb (végig) + teljes fazon:', '10 900.-'],
					['Hát:', '5 200.-'],
					['Mellkas:', '3 700.-'],
					['Has:', '2 600.-'],
					['Mellkas + has:', '5 800.-'],
				],
			},
			{
				title: 'Festések',
				rows: [
					['Szempillafestés:', '2 400.-'],
					['Szemöldökfestés:', '1 500.-'],
					['Szempilla,- szemöldökfestés és szedés:', '5 300.-'],
					['Szemöldökszedés (kézi):', '1 400.-'],
				],
			},
			{
				title: 'Sminkek',
				rows: [
					['Nappali:', '7 400.-'],
					['Alkalmi:', '8 400.-'],
					['Mennyasszonyi:', '15 500.-'],
					['Szempilladauer:', '8 000.-'],
				],
			},
			{
				title: 'Testmasszázs',
				rows: [
					['Karok (30 perc):', '6 000.-'],
					['Lábak (30 perc):', '7 200.-'],
					['Hát (40 perc):', '8 200.-'],
					['Hát + kar:', '10 000.-'],
					['Egész test (1,5 óra):', '11 500.-'],
				],
			},
		],
		[],
	);

	// RENDERES
	const priceList = useMemo<JSX.Element[]>(
		() =>
			priceTables.map((table, idx) => (
				<table key={`priceTable-${idx}`}>
					<thead>
						<tr>
							<th colSpan={2}>{table.title}</th>
						</tr>
					</thead>
					<tbody>
						{table.rows.map((row, idx) => (
							<tr key={`tableRow-${idx}`} className={classes.tableRow}>
								<td>{row?.[0]}</td>
								<td>
									<span>{row?.[1]}</span>
									{row?.[2] && <span>&nbsp;{row?.[2]}</span>}
								</td>
							</tr>
						))}
					</tbody>
				</table>
			)),
		[priceTables],
	);

	return (
		<div className={classes.priceListPage}>
			<main>
				<h1>Árlista (2026)</h1>
				{priceList}
			</main>
			<footer>
				<Link to="/">
					<button>Vissza a főoldalra</button>
				</Link>
			</footer>
		</div>
	);
}

export default PriceListPage;
